import BaseSplashScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseSplashScreenMediator";

export default class SplashLoadScreenMediator extends BaseSplashScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config) {
        super(target, dispatcher, languagePack, layoutManager, startup, soundManager, config);
    }

}